import React from "react";
import MCSAlertSuccess from "../components/MCSAlertSuccess";
import MCSAlertError from "../components/MCSAlertError";
import MCSAlertGlobalError from "../components/MCSAlertGlobalError";

export const GlobalAlertContext = React.createContext();
class GlobalAlertProvider extends React.Component {
  constructor(props) {
    super(props);

    const setSuccessMessage = (message) => {
      this.setState({ successMessage: message });
      this.state.toggleShowSuccessAlert(true);
    };

    const setErrorMessage = (message) => {
      this.setState({ errorMessage: message });
      this.state.toggleShowErrorAlert(true);
    };

    const setGlobalErrorMessage = (message) => {
      this.setState({ globalErrorMessage: message });
      toggleShowGlobalErrorAlert(true);
    };

    const hideGlobalErrorMessage = () => {
      this.setState({ globalErrorMessage: "" });
      toggleShowGlobalErrorAlert(false);
    };

    const toggleShowSuccessAlert = (show) => {
      this.setState({ showSuccessAlert: show });
    };

    const toggleShowErrorAlert = (show) => {
      this.setState({ showErrorAlert: show });
    };

    const toggleShowGlobalErrorAlert = (show) => {
      this.setState({ showGlobalErrorAlert: show });
    };

    this.state = {
      successMessage: "",
      showSuccessAlert: false,
      setSuccessMessage: setSuccessMessage,
      toggleShowSuccessAlert: toggleShowSuccessAlert,

      errorMessage: "",
      showErrorAlert: false,
      toggleShowErrorAlert: toggleShowErrorAlert,
      setErrorMessage: setErrorMessage,

      globalErrorMessage: "",
      showGlobalErrorAlert: false,
      setGlobalErrorMessage: setGlobalErrorMessage,
      hideGlobalErrorMessage: hideGlobalErrorMessage,
    };
  }

  render() {
    return (
      <GlobalAlertContext.Provider value={this.state}>
        <MCSAlertSuccess
          successMessage={this.state.successMessage}
          showAlert={this.state.showSuccessAlert}
          setSuccessMessage={this.state.setSuccessMessage}
          toggleShowSuccessAlert={this.state.toggleShowSuccessAlert}
        />
        <MCSAlertError
          errorMessage={this.state.errorMessage}
          showAlert={this.state.showErrorAlert}
          setErrorMessage={this.state.setErrorMessage}
          toggleShowErrorAlert={this.state.toggleShowErrorAlert}
        />
        <MCSAlertGlobalError
          errorMessage={this.state.globalErrorMessage}
          showAlert={this.state.showGlobalErrorAlert}
          hideAlert={this.state.hideGlobalErrorMessage}
        />
        {this.props.children}
      </GlobalAlertContext.Provider>
    );
  }
}

export default GlobalAlertProvider;
